<template>
    <AuthenticatedShell full-bleed-brand>
        <div class="ea-config-layout tp-main-layout tp-main-app tp-main-app--thread">
            <div class="ea-config-scroll tp-main-ea-scroll">
                <div class="wizard tp-main-wizard">
                    <section class="section command-list primary tp-main-command">
                        <section class="section message-list primary tp-chat-thread" ref="chatContainer">
                            <div class="message-list-content">
                                <div class="content-wrapper primary tp-chat-feed">
                                    <article class="tp-chat-turn" aria-label="Pedido inicial">
                                        <div class="wrapper-inner asking tp-chat-user">
                                            <div class="content-text">
                                                <div class="desc">
                                                    <p v-if="currentRunIa && currentRunIa.parameters">
                                                        <template
                                                            v-for="param in currentRunIa.parameters"
                                                            :key="param.property"
                                                        >
                                                            {{
                                                                param.property.charAt(0).toUpperCase() +
                                                                param.property.slice(1).replace(/_/g, ' ')
                                                            }}: {{ param.value }}.<br /><br />
                                                        </template>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="wrapper-inner answer tp-chat-assistant">
                                            <div class="tp-chat-assistant-head">
                                                <div class="content-icon">
                                                    <div class="icon">
                                                        <img
                                                            src="/assets/images/logo/logo-escolarai-b.svg"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div class="value-text">
                                                        <div class="title">
                                                            <h3>{{ currentCrew?.name }}</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="content-value tp-chat-assistant-card">
                                                <div
                                                    class="value-text tp-chat-prose"
                                                    v-html="responseRunIa?.output"
                                                ></div>
                                            </div>
                                        </div>
                                    </article>

                                    <article
                                        v-for="(message, index) in chatMessages"
                                        :key="'follow-' + index"
                                        class="tp-chat-turn"
                                        :aria-label="'Mensagem ' + (index + 1)"
                                    >
                                        <div class="wrapper-inner asking tp-chat-user">
                                            <div class="content-text">
                                                <div class="desc">
                                                    <p>{{ message }}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="wrapper-inner answer tp-chat-assistant">
                                            <div class="tp-chat-assistant-head">
                                                <div class="content-icon">
                                                    <div class="icon">
                                                        <img
                                                            src="/assets/images/logo/logo-escolarai-b.svg"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div class="value-text">
                                                        <div class="title">
                                                            <h3>{{ currentCrew?.name }}</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="content-value tp-chat-assistant-card">
                                                <div
                                                    class="value-text tp-chat-prose"
                                                    v-html="replyMessages[index] || ''"
                                                ></div>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            </div>
                            <div class="loading-dots" v-if="showLoading">
                                <div class="loading-dots-content">
                                    <span class="dot"></span>
                                    <span class="dot"></span>
                                    <span class="dot"></span>
                                </div>
                            </div>
                        </section>
                    </section>
                </div>
            </div>

            <section class="section message-box primary tp-main-composer">
                <div class="message-box-content">
                    <div class="content-form">
                        <div class="form-group">
                            <div class="form-input">
                                <span class="link">
                                    <a class="link-form" @click="setFavoriteRunIa">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                d="M12.2963 2.29489C12.3402 2.20635 12.4079 2.13183 12.4918 2.07972C12.5757 2.02761 12.6725 2 12.7713 2C12.8701 2 12.9669 2.02761 13.0509 2.07972C13.1348 2.13183 13.2025 2.20635 13.2463 2.29489L15.5563 6.97389C15.7085 7.28186 15.9331 7.5483 16.211 7.75035C16.4888 7.95239 16.8115 8.08401 17.1513 8.13389L22.3173 8.88989C22.4152 8.90408 22.5072 8.94537 22.5828 9.00909C22.6585 9.07282 22.7148 9.15644 22.7453 9.2505C22.7759 9.34456 22.7796 9.4453 22.7559 9.54133C22.7322 9.63736 22.6821 9.72485 22.6113 9.79389L18.8753 13.4319C18.6289 13.672 18.4446 13.9684 18.3382 14.2955C18.2317 14.6227 18.2064 14.9708 18.2643 15.3099L19.1463 20.4499C19.1636 20.5477 19.153 20.6485 19.1158 20.7406C19.0786 20.8327 19.0163 20.9125 18.9359 20.9709C18.8555 21.0293 18.7603 21.0639 18.6612 21.0708C18.5621 21.0777 18.463 21.0566 18.3753 21.0099L13.7573 18.5819C13.453 18.4221 13.1145 18.3386 12.7708 18.3386C12.4272 18.3386 12.0886 18.4221 11.7843 18.5819L7.16733 21.0099C7.07966 21.0563 6.98073 21.0772 6.88178 21.0701C6.78284 21.0631 6.68785 21.0285 6.60763 20.9701C6.5274 20.9118 6.46516 20.8321 6.42799 20.7401C6.39081 20.6481 6.38019 20.5476 6.39733 20.4499L7.27833 15.3109C7.33653 14.9716 7.31131 14.6233 7.20487 14.2959C7.09842 13.9686 6.91394 13.672 6.66733 13.4319L2.93133 9.79489C2.85992 9.72593 2.80932 9.63829 2.78529 9.54197C2.76126 9.44565 2.76477 9.34451 2.79541 9.25008C2.82605 9.15566 2.8826 9.07174 2.95861 9.00788C3.03462 8.94402 3.12703 8.90279 3.22533 8.88889L8.39033 8.13389C8.73059 8.08439 9.05372 7.95295 9.33191 7.75088C9.61011 7.54881 9.83503 7.28216 9.98733 6.97389L12.2963 2.29489Z"
                                                stroke="#FFFFFF"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                    </a>
                                </span>
                                <span class="input">
                                    <input
                                        type="search"
                                        v-model="hasMessage"
                                        class="form-control"
                                        placeholder="Escreva a tarefa que precisa ser feita"
                                        @keyup.enter="getReplyRunIa"
                                    />
                                </span>
                                <span class="button">
                                    <button type="button" class="btn btn-block btn-form" @click="getReplyRunIa">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M4.79495 5.12264C3.06804 4.50448 1.48934 6.34298 2.36147 7.95659L4.91684 12.6845L2.45796 16.9331C1.53522 18.5274 3.07596 20.4157 4.82302 19.8317L20.5763 14.5658C22.3773 13.9637 22.4041 11.4259 20.6163 10.7859L4.79495 5.12264ZM17.2389 11.7012L4.12092 7.00564L6.65881 11.7012H17.2389ZM6.63923 13.7012L4.18895 17.9349L16.854 13.7012H6.63923Z"
                                                fill="white"
                                            />
                                        </svg>
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="content-caption">
                        <div class="caption">
                            <span>
                                Lembre-se de sempre revisar! Os textos são gerados por inteligência artificial e podem
                                conter informações imprecisas.
                            </span>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </AuthenticatedShell>
</template>

<script>
import AuthenticatedShell from '@/components/layout/AuthenticatedShell.vue';
import parameters from '@/utils/parameters.js';
import { mapState, mapActions } from 'vuex';
import order from '@/utils/order';
import { toast } from 'vue3-toastify';

const CHAT_THREAD_SESSION_KEY = 'ea-chat-thread-cache';

export default {
    components: {
        AuthenticatedShell
    },
    data() {
        return {
            hasMessage: '',
            menssageCrew: '',
            crews: [],
            userData: {
                name: '',
                email: '',
                password: ''
            },
            parameters: [],
            responseRunIa: null,
            chatMessages: [],
            replyMessages: [],
            showLoading: false
        };
    },
    computed: {
        ...mapState(['token', 'user', 'currentCrew', 'currentRunIa', 'userInfoData'])
    },
    mounted() {
        if (this.tryRestoreThreadFromSession()) {
            this.$nextTick(() => this.scrollToBottom());
            return;
        }
        this.getResponseRunIa();
    },
    updated() {
        this.scrollToBottom();
    },
    methods: {
        ...mapActions([
            'getCrews',
            'storeIsVisibleSideBarGenericModal',
            'storeFieldsModalGeneric',
            'storeCurrentCrew',
            'storeUserInfoData',
            'storeCrewsList'
        ]),
        async getParameters(id, crew) {
            try {
                const response = await parameters.getParameters(this.token, id);
                this.storeIsVisibleSideBarGenericModal({ isVisibleSideBarGenericModal: true });
                this.storeFieldsModalGeneric({ fields: response });
                this.storeCurrentCrew({ currentCrew: crew });
                this.parameters = response;
            } catch (error) {
                console.error('Erro ao buscar parâmetros:', error);
            }
        },
        notify(text) {
            const message = text.title + ' favoritada com sucesso.';
            toast(message, {
                autoClose: 3000,
                position: 'top-right',
                theme: 'light',
                type: 'success',
                dangerouslyHTMLString: true
            });
        },
        buildThreadCacheKey() {
            const crewId = this.currentCrew?.id ?? this.currentRunIa?.crew_id ?? '';
            const params = this.currentRunIa?.parameters ?? [];
            const body = params
                .map(p => `${String(p.property)}=${String(p.value ?? '')}`)
                .sort()
                .join('|');
            return `v1:${crewId}:${body}`;
        },
        tryRestoreThreadFromSession() {
            try {
                const raw = sessionStorage.getItem(CHAT_THREAD_SESSION_KEY);
                if (!raw) return false;
                const parsed = JSON.parse(raw);
                if (!parsed || parsed.cacheKey !== this.buildThreadCacheKey()) return false;
                if (!parsed.responseRunIa || parsed.responseRunIa.output == null) return false;
                this.responseRunIa = parsed.responseRunIa;
                this.chatMessages = Array.isArray(parsed.chatMessages) ? [...parsed.chatMessages] : [];
                this.replyMessages = Array.isArray(parsed.replyMessages) ? [...parsed.replyMessages] : [];
                return true;
            } catch (e) {
                return false;
            }
        },
        persistThreadToSession() {
            try {
                if (!this.responseRunIa || this.responseRunIa.output == null) return;
                sessionStorage.setItem(
                    CHAT_THREAD_SESSION_KEY,
                    JSON.stringify({
                        cacheKey: this.buildThreadCacheKey(),
                        responseRunIa: this.responseRunIa,
                        chatMessages: this.chatMessages,
                        replyMessages: this.replyMessages
                    })
                );
            } catch (e) {
                /* quota / private mode */
            }
        },
        async getResponseRunIa() {
            this.showLoading = true;
            const payload = {
                id: this.currentRunIa?.id || 0,
                type_engine: this.currentRunIa?.type_engine || 1,
                crew_id: this.currentRunIa?.crew_id || this.currentCrew.id,
                request_type: this.currentRunIa?.request_type || 1,
                status: this.currentRunIa?.status || 0,
                parameters: this.currentRunIa?.parameters || []
            };
            try {
                const response = await order.order(payload, this.token);
                if (response?.output) {
                    response.output = response.output
                        .replace(/^# (.*$)/gm, '<h1>$1</h1>')
                        .replace(/^## (.*$)/gm, '<h2>$1</h2>')
                        .replace(/^### (.*$)/gm, '<h3>$1</h3>')
                        .replace(/^#### (.*$)/gm, '<h4>$1</h4>')
                        .replace(/^##### (.*$)/gm, '<h5>$1</h5>')
                        .replace(/^###### (.*$)/gm, '<h6>$1</h6>')
                        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                        .replace(/\*(.*?)\*/g, '<em>$1</em>')
                        .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>')
                        .replace(/`([^`]+)`/g, '<code>$1</code>')
                        .replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>')
                        .replace(/^> (.*$)/gm, '<blockquote>$1</blockquote>')
                        .replace(/^- (.*$)/gm, '<li>$1</li>')
                        .replace(/\n/g, '<br> ');
                }
                if (response?.output !== undefined) {
                    console.log(response.output);
                }
                this.responseRunIa = response;
                this.showLoading = false;
                console.log(response);
                this.persistThreadToSession();
                this.$nextTick(() => {
                    this.scrollToBottom();
                });
            } catch (error) {
                console.error('Erro ao buscar resposta da IA:', error);
                this.showLoading = false;
            }
        },
        async getReplyRunIa() {
            if (!this.hasMessage) return;
            if (!this.responseRunIa?.id) return;

            this.showLoading = true;
            this.chatMessages.push(this.hasMessage);
            const message = this.hasMessage;
            this.hasMessage = '';

            const payload = {
                id: this.responseRunIa.id,
                type_engine: 1,
                crew_id: this.currentCrew.id,
                request_type: 1,
                status: 0,
                parameters: [
                    {
                        type: 1,
                        property: 'request',
                        value: message
                    }
                ]
            };

            try {
                const response = await order.order(payload, this.token);
                if (response?.output) {
                    response.output = response.output
                        .replace(/^# (.*$)/gm, '<h1>$1</h1>')
                        .replace(/^## (.*$)/gm, '<h2>$1</h2>')
                        .replace(/^### (.*$)/gm, '<h3>$1</h3>')
                        .replace(/^#### (.*$)/gm, '<h4>$1</h4>')
                        .replace(/^##### (.*$)/gm, '<h5>$1</h5>')
                        .replace(/^###### (.*$)/gm, '<h6>$1</h6>')
                        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                        .replace(/\*(.*?)\*/g, '<em>$1</em>')
                        .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>')
                        .replace(/`([^`]+)`/g, '<code>$1</code>')
                        .replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>')
                        .replace(/^> (.*$)/gm, '<blockquote>$1</blockquote>')
                        .replace(/^- (.*$)/gm, '<li>$1</li>')
                        .replace(/\n/g, '<br> ');
                }
                this.replyMessages.push(response?.output ?? '');
                this.showLoading = false;
                this.persistThreadToSession();
                this.$nextTick(() => {
                    this.scrollToBottom();
                });
            } catch (error) {
                console.error('Erro ao buscar resposta da IA:', error);
                this.showLoading = false;
            }
        },
        scrollToBottom() {
            const container = this.$refs.chatContainer;
            if (container) {
                container.scrollTop = container.scrollHeight;
            }
        },
        async setFavoriteRunIa() {
            if (!this.responseRunIa?.id) return;
            const payload = {
                id: this.responseRunIa.id
            };
            try {
                const response = await order.setOrderFavorite(payload, this.token);
                console.log(response);
                this.notify(response);
            } catch (error) {
                console.error('Erro ao favoritar conversa:', error);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.ea-config-layout.tp-main-layout {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
}

.ea-config-scroll.tp-main-ea-scroll {
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
}

.tp-main-app--thread .ea-config-scroll.tp-main-ea-scroll {
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.tp-main-wizard,
.tp-main-command {
    width: 100%;
    max-width: 100%;
}

.tp-main-app--thread .tp-main-wizard {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
}

.tp-main-app--thread .tp-main-command.section.command-list.primary {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
}

.tp-main-composer {
    flex-shrink: 0;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 0.5rem clamp(0.65rem, 1.5vw, 1rem) 0.65rem !important;
    background: #0b0b0d !important;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.tp-main-composer .message-box-content {
    max-width: 48rem;
    width: 100% !important;
    margin-left: auto !important;
    margin-right: auto !important;
}
</style>
<style lang="scss">
html:has(.tp-main-app--thread),
body:has(.tp-main-app--thread) {
    overflow: hidden;
    height: 100%;
}

.ea-brand-shell .message-box.primary.tp-main-composer {
    position: relative !important;
    left: auto !important;
    bottom: auto !important;
    transform: none !important;
    width: 100% !important;
}
</style>
<style scoped>
.loading-dots {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 1rem 1.5rem;
}

.loading-dots-content {
    display: flex;
    gap: 8px;
}

.dot {
    width: 8px;
    height: 8px;
    background-color: rgba(79, 204, 234, 0.9);
    border-radius: 50%;
    animation: fade 1.5s infinite;
}

.dot:nth-child(2) {
    animation-delay: 0.5s;
}

.dot:nth-child(3) {
    animation-delay: 1s;
}

@keyframes fade {
    0%,
    100% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
}

.tp-chat-thread {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    width: 100%;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.tp-chat-thread::-webkit-scrollbar {
    width: 0;
    height: 0;
}

.tp-chat-feed {
    width: 100%;
    margin: 0 auto;
    padding: 0.5rem 0.75rem 2rem;
    box-sizing: border-box;
}

.tp-chat-turn {
    margin-bottom: 1.75rem;
}

.tp-chat-turn:last-child {
    margin-bottom: 0.5rem;
}

.tp-chat-user {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 0.25rem;
}

.tp-chat-user .content-text {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-right: 0;
}

.tp-chat-user .desc {
    max-width: min(88%, 34rem);
    width: auto;
    margin: 0;
    padding: 0.7rem 1rem;
    background: #2a2b32;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 18px 18px 4px 18px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
}

.tp-chat-user .desc p {
    margin: 0;
    color: #f4f4f5;
    font-size: 15px;
    line-height: 1.55;
    white-space: pre-wrap;
    word-break: break-word;
}

.tp-chat-assistant {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
    margin-top: 1rem;
    width: 100%;
}

.tp-chat-assistant-head .content-icon {
    display: flex;
    align-items: center;
    gap: 0.65rem;
}

.tp-chat-assistant-head .icon img {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    display: block;
}

.tp-chat-assistant-head .value-text .title h3 {
    margin: 0;
    font-size: 0.9375rem;
    font-weight: 600;
    color: #f2f3f5;
    letter-spacing: -0.01em;
}

.tp-chat-assistant-card {
    width: 100%;
    padding: 1rem 1.15rem 1.15rem;
    border-radius: 14px;
    background: #1c1d22;
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 1px 0 rgba(255, 255, 255, 0.04);
    color: #eaecef;
}

.tp-chat-assistant-card .value-text.tp-chat-prose {
    color: #eaecef;
    font-size: 15px;
    line-height: 1.65;
    word-break: break-word;
}

.tp-chat-prose :deep(strong) {
    color: #f6f7f9;
    font-weight: 600;
}

.tp-chat-prose :deep(em) {
    color: #e4e8f0;
    font-style: italic;
}

.tp-chat-prose :deep(p) {
    margin: 0 0 0.85em;
    color: #e8eaef;
    font-size: 15px;
    line-height: 1.65;
    word-break: break-word;
}

.tp-chat-prose :deep(p:last-child) {
    margin-bottom: 0;
}

.tp-chat-prose :deep(h1),
.tp-chat-prose :deep(h2),
.tp-chat-prose :deep(h3),
.tp-chat-prose :deep(h4) {
    margin: 1.1em 0 0.45em;
    color: #f2f3f5;
    font-weight: 600;
    line-height: 1.3;
}

.tp-chat-prose :deep(h1:first-child),
.tp-chat-prose :deep(h2:first-child),
.tp-chat-prose :deep(h3:first-child) {
    margin-top: 0;
}

.tp-chat-prose :deep(code) {
    font-size: 0.88em;
    padding: 0.12em 0.35em;
    border-radius: 6px;
    background: rgba(0, 0, 0, 0.35);
    border: 1px solid rgba(255, 255, 255, 0.08);
    color: #e2e8f0;
}

.tp-chat-prose :deep(pre) {
    margin: 0.75em 0;
    padding: 0.85rem 1rem;
    border-radius: 10px;
    background: #121316;
    border: 1px solid rgba(255, 255, 255, 0.08);
    overflow-x: auto;
}

.tp-chat-prose :deep(pre code) {
    padding: 0;
    border: none;
    background: transparent;
    font-size: 13px;
    line-height: 1.5;
}

.tp-chat-prose :deep(a) {
    color: #7dd3fc;
    text-decoration: underline;
    text-underline-offset: 2px;
}

.tp-chat-prose :deep(blockquote) {
    margin: 0.65em 0;
    padding-left: 0.85rem;
    border-left: 3px solid rgba(206, 255, 31, 0.45);
    color: #c8cdd8;
}

.tp-chat-prose :deep(li) {
    margin: 0.25em 0;
    color: #e8eaef;
}
</style>
